import React from 'react';

export default function LoadingScreen() {
  return (
    <div className="view on" data-testid="loading-screen" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
      <div className="status-dot" style={{ margin: '0 auto 24px' }}></div>
      <h2 style={{ fontWeight: 400 }}>Loading assessment...</h2>
      <p className="dim">Preparing your questions</p>
    </div>
  );
}
